<template>
  <v-container>
    <v-layout text-center wrap>
      <v-row no-gutters>
        <v-col cols="12">
          <v-card flat>
            <v-card-text>
              <v-tabs
                background-color="white"
                color="deep-purple accent-4"
                left
              >
                <v-tab>Employees</v-tab>
                <v-tab>Dependents</v-tab>
                <v-tab-item>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12">
                        <Employee />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>

                <v-tab-item>
                  <v-container fluid>
                    <v-row>
                      <v-col cols="12">
                        <Dependent />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-tab-item>
              </v-tabs>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</template>

<script>
import Employee from "@/components/Employee";
import Dependent from "@/components/Dependent";
import HRLayout from "@/layouts/HRLayout";

export default {
  components: {
    Employee,
    Dependent
  },
  created() {
    this.$emit("update:layout", HRLayout);
  }
};
</script>
